<template>
  <page>
    <template slot="content">
    <help-content :title="'ランキングに表示されている名前を変更したい'">
      <template slot="content">
        <div class="text">
          「メニュー」に表示されている名前をタップするか、「メニュー」＞「MYグループ」の表示名を修正してください。
        </div>
        <div class="text">
          ※ランキングに表示している自分をタップし、「会員情報」画面の名前をタップして修正してください。<br><br>
          ※プロフィールの「ユーザー名」はランキングに表示されず、本人しか閲覧できません。
        </div>
        <img class="picture" src="../assets/images/q_and_a/H34.png">
      </template>
    </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help34.vue